module.exports = __webpack_public_path__ + "img/2017.08410703.png";